import Container from "@components/Container/Container";
import { useWindowSize } from "@hooks/useWindowSize";

import SCAFooterDesktop from "./SCAFooterDesktop";
import SCAFooterMobile from "./SCAFooterMobile";

/**
 * Component to display footer in SCA pages
 */
const SCAFooter = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <footer
      data-testid="sca-footer-component"
      className="mb-4 bg-gray-850 py-9 font-public-sans"
    >
      <Container rootClassName="flex flex-row justify-center text-white">
        {isScreenLG ? <SCAFooterDesktop /> : <SCAFooterMobile />}
      </Container>
    </footer>
  );
};

export default SCAFooter;
